import { Link } from 'react-router-dom';

import BtnLoader from '@components/BtnLoader';
import './style.scss';

const Button = ({
  type,
  className,
  theme,
  size,
  mode,
  title,
  disabled,
  onClick,
  style,
  prefix,
  suffix,
  href,
  rel,
  target,
  linkTo,
  loading,
}) => {
  const classNames = [
    'btn',
    className || '',
    theme ? `btn_${theme}` : '',
    size ? `btn_${size}` : '',
    mode ? `btn_${mode}` : '',
    loading ? 'btn-loading' : '',
  ];

  return (
    type === 'submit' || type === 'button' ? (
      <button
        type={type}
        title={title}
        className={classNames.join(' ').trim()}
        onClick={onClick}
        style={style}
        disabled={disabled || ''}
      >

        {prefix || null}

        {loading
          ? <BtnLoader />
          : null
        }

        <span>{title}</span>

        {suffix || null}
      </button>

    ) : href ? (
      <a
        href={href}
        type={type}
        title={title}
        className={classNames.join(' ').trim()}
        onClick={onClick}
        style={style}
        disabled={disabled || ''}
        target={target}
        rel={rel}
      >

        {prefix || null}

        {loading
          ? <BtnLoader />
          : null
        }

        <span>{title}</span>

        {suffix || null}
      </a>
    ) : linkTo ? (
      <Link
        to={linkTo}
        className={classNames.join(' ').trim()}
        style={style}
      >

        {prefix || null}

        {loading
          ? <BtnLoader />
          : null
        }

        <span>{title}</span>

        {suffix || null}
      </Link>
    ) : (
      <div
        className={classNames.join(' ').trim()}
        onClick={onClick}
        style={style}
        disabled={disabled || ''}
      >
        {prefix || null}

        {loading
          ? <BtnLoader />
          : null
        }

        <span>{title}</span>

        {suffix || null}
      </div>
    )
  );
};

export default Button;
